import React from 'react';
import { Button as AntButton } from 'antd-v5';
import './style.less';
function Button(props) {
  const { className, ...nativeProps } = props;

  return <AntButton {...nativeProps} className={`ui-button ${className}`} />;
}
export default Button;
